// extracted by mini-css-extract-plugin
module.exports = {"main":"_2XbXVqbiFiVCry85ILOu04","imgCont":"_2GsRsv28T0G7XfjoeAPJ4m","playCont":"_1_23ea8hnuNfHPs_9cECCE","play":"_10lFnNz6aCBb6B59oXLyHg","videoCont":"_3SQk9NgwE01sdLMPezkdD"};